<template>
    <div class="sub-body flex">
        <div class="sub-body-wrap relative">
            <TTextArea v-model="subBody" :key="sub._id" rows="6" @pasteFile="val => addFile(val)"/>
            <InputFileButton ref="select_file" class="select-file" accept="image/*" @change="addFile"/>
        </div>
        <Images class="ml-5" :images="imagesForSub" @deleteImage="val  => deleteFile(val)"/>
        <RelatedElements class="ml-5" :element="sub" :relatedElementsForTask="false"/>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import { debounce } from 'lodash'
    import TTextArea from '../misc/TTextArea'
    import RelatedElements from './RelatedElements/RelatedElements'
    import Images from '../popups/Images'
    import { imagesOfItems } from '../../helpers'
        import InputFileButton from '@/components/misc/InputFileButton.vue'
export default {
        name: 'SubBody',
        components: {
            InputFileButton,
          TTextArea,
          RelatedElements,
          Images
        },
        props: [
          'sub',
        ],
        data() {
          return {
            
          }
        },
        computed:{
            ...mapGetters(["current", "current_task"]),
            subBody:{
                get(val){
                    return this.sub.body
                },
                set: debounce(function(newVal) {
                    this.editSub({_id: this.current._id, task_id: this.current_task._id, sub_id: this.sub._id, text: newVal})
                }, 450)
            },
            imagesForSub() {
                const parsingLinks = imagesOfItems(this.sub)
                const set = imagesOfItems(this.sub) && [...(this.sub.blockedLinks || [])] && new Set(this.sub.blockedLinks)
                const links = parsingLinks.filter(e => !set.has(e))
                const subImages = this.sub.images && this.sub.images.map((el) => this.$root.origin + '/api' + el)
                return [...(subImages || []), ...links]
            }
        },
        methods:{
          ...mapActions(['editSub', 'uploadFiles', 'setImagesToSub', 'setBlockedLinksToSub']),
            async addFile(e) {
                const file = (e.target && e.target.files[0]) || e
                if (file) {                    
                    const formData = new FormData()
                    formData.append('file', file)
                    const filesRes = await this.uploadFiles(formData)
                    await this.setImagesToSub({_id: this.current._id, task_id: this.current_task._id, sub_id: this.sub._id, images: [...(this.sub.images || []), ...filesRes.map((el) => el.path)]})
                }
            },
            async deleteFile(e) {
                if (e.includes(this.$root.origin + "/api")) {
                    this.sub.images.splice(this.sub.images.findIndex(image => image == e.slice(24)),1)
                    await this.setImagesToSub({_id: this.current._id, task_id: this.current_task._id, sub_id: this.sub._id, images: [...(this.sub.images || [])]})
                } else {
                    this.sub.blockedLinks.push(e)
                    await this.setBlockedLinksToSub({_id: this.current._id, task_id: this.current_task._id, sub_id: this.sub._id, blockedLinks: [...(this.sub.blockedLinks || [])]})
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
.sub-body {
    .sub-body-wrap {
        .t-textarea {
            max-height: 350px;
            overflow-y: scroll;
        }
        .t-textarea::-webkit-scrollbar {
            width: 9px;
            background-color: #FAFAFA;
        }
        ::-webkit-scrollbar-thumb {
            background-color: #EDEDED;
        }
        .select-file{
            position: absolute;
            bottom: 0;
            right: 20px;
        }
    }
}
</style>